<template>
  <div class="container-fluid text-start border-bottom">
    <a
      href="https://github.com/nroduit/Weasis/releases/download/v4.5.1/Weasis-4.5.1-x86-64.msi"
      target="_blank"
      rel="noopener noreferrer"
      style="font-size: 0.8em"
      class="highlight"
      >{{ t('download_viewer') }}
      <i class="fa-fw fas fa-download" style="font-size: 0.8em"></i
    ></a>
  </div>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-2">
        <ul class="list-group">
          <li
            v-for="device in deviceStore.devices"
            :key="device.id"
            @click="selectDevice(device)"
            :class="[
              'list-group-item',
              { active: device.id === selectedDevice?.id }
            ]"
            style="cursor: pointer"
          >
            {{ device.name }}
          </li>
        </ul>
      </div>
      <div class="col-10">
        <div class="row vl-parent">
          <loading
            v-model:active="isLoading"
            :can-cancel="false"
            loader="dots"
            :opacity="0.6"
            :is-full-page="false"
          />
          <div
            class="container py-5 my-5"
            v-if="studyStore.studies.length === 0 && !isLoading"
          >
            {{ t('no_dicom_files') }}
          </div>
          <template v-else v-for="study in studyStore.studies" :key="study.id">
            <div
              class="col-3 col-xl-2 mb-4"
              v-for="file in study.storedFiles"
              :key="file.fileName"
            >
              <div
                class="card position-relative"
                style="background-color: #eeeeee"
              >
                <Popper
                  class="info-icon"
                  content="TEST"
                  :hover="true"
                  placement="right"
                  :arrow="true"
                  z-index="99999999"
                >
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z"
                        fill="#1C274C"
                      ></path>
                      <path
                        d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
                        fill="#1C274C"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"
                        fill="#1C274C"
                      ></path>
                    </g>
                  </svg>
                  <template #content>
                    <div class="text-start">
                      <b>{{ t('study') }}:</b><br />
                      <div v-if="study.studyDescription">
                        {{ t('study_description') }}:
                        {{ study.studyDescription }}
                      </div>
                      <div v-if="study.studyDateTime !== ''">
                        {{ t('study_date') }}:
                        {{ getDateFormat(study.studyDateTime) }}
                      </div>
                    </div>
                    <div class="text-start mt-2">
                      <b>{{ t('patient') }}:</b><br />
                      <div v-if="study?.patient?.patientName !== ''">
                        {{ t('patient_name') }}:
                        {{ study.patient.patientName.replaceAll('^', ' ') }}
                      </div>
                      <div v-if="study?.patient?.patientID !== ''">
                        {{ t('patient_id') }}: {{ study.patient.patientID }}
                      </div>
                    </div>
                  </template>
                </Popper>
                <Popper
                  v-if="
                    file.altrisExamination?.status === 'UPLOAD_ERROR' ||
                    file.altrisExamination?.status === 'PDF_ERROR'
                  "
                  class="info-icon-error"
                  :hover="true"
                  placement="right"
                  :arrow="true"
                  z-index="99999999"
                >
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="-2.4 -2.4 28.80 28.80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#CCCCCC"
                      stroke-width="1.7759999999999998"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M12 8V12"
                        stroke="#f90b0b"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M12 16.0195V16"
                        stroke="#f90b0b"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#f90b0b"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></circle>
                    </g>
                  </svg>
                  <template #content>
                    <p>{{ file.altrisExamination?.errorMessage }}</p>
                  </template>
                </Popper>
                <img
                  src="../assets/Weasis.png"
                  class="card-img-top mx-auto mt-4 cursor"
                  alt="DICOM file"
                  style="width: 80px"
                  @click="openDicomFile(file.id)"
                />
                <div class="card-body">
                  <h5 class="card-title fw-semibold">
                    {{ getDateFormat(study?.studyDateTime) }}
                  </h5>
                </div>
                <div class="card-footer px-0" v-if="file.isEligibleForAltris">
                  <div class="d-flex justify-content-between w-100">
                    <button
                      class="btn btn-danger mx-auto btn-custom btn-danger bg-danger w-auto"
                      disabled
                      v-if="file.altrisExamination?.status === 'PENDING'"
                    >
                      <span
                        class="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {{ t('in_processing') }}
                    </button>
                    <button
                      class="btn btn-danger btn-custom mx-auto"
                      style="background-color: #23408e"
                      v-else-if="file.altrisExamination?.status === 'SUCCESS'"
                      @click="getAltrisPdf(file.id)"
                    >
                      {{ t('pdf_ai') }}
                    </button>
                    <button
                      class="btn btn-danger btn-custom mx-auto"
                      style="background-color: #23408e"
                      v-else
                      @click="uploadDicomToAltris(file.id)"
                    >
                      {{ t('ai_analysis') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from 'vue'
import { useDeviceStore } from '../store/device'
import { useStudyStore } from '../store/study'
import { useSessionStore } from '../store/session'
import apiService from '@/services/api'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import { useI18n } from 'vue-i18n'
import 'vue-loading-overlay/dist/css/index.css'
import { useToast } from 'vue-toastification'

export default defineComponent({
  components: { Loading },
  setup() {
    const toast = useToast()
    const deviceStore = useDeviceStore()
    const selectedDevice = ref<{ id: string; name: string } | null>(null)
    const studyStore = useStudyStore()
    const sessionStore = useSessionStore()
    const isLoading = ref(false)
    const apiBaseURL = process.env.VUE_APP_API_BASE_URL
    const { t } = useI18n()
    // Refresh interval for pending files
    let refreshInterval: any

    onMounted(async () => {
      await deviceStore.fetchDevices()
      if (deviceStore.devices.length > 0) {
        selectDevice(deviceStore.devices[0])
      }

      startAutoRefresh()
    })

    onUnmounted(() => {
      clearInterval(refreshInterval)
    })

    const startAutoRefresh = () => {
      refreshInterval = setInterval(async () => {
        const hasPending = studyStore.studies.some((study) =>
          study.storedFiles.some(
            (file) => file.altrisExamination?.status === 'PENDING'
          )
        )
        if (
          hasPending &&
          selectedDevice.value &&
          parseInt(selectedDevice.value.id) > 0
        ) {
          await studyStore.fetchStudies(
            sessionStore.patientId,
            selectedDevice.value.id
          )
        }
      }, 10000)
    }

    const selectDevice = async (device: any) => {
      selectedDevice.value = device
      if (sessionStore.patientId) {
        isLoading.value = true
        await studyStore.fetchStudies(sessionStore.patientId, device.id)
        isLoading.value = false
      }
    }

    function openDicomFile(fileId: string) {
      const originalUrl = `${apiBaseURL}/study/weasis/file/${fileId}?jwt=${sessionStore.jwt}`
      const encodedUrl = encodeURIComponent(originalUrl)
      const initialPart = '%24dicom%3Aget+-r+'
      const weasisUrl = `weasis://${initialPart}${encodedUrl}`
      window.open(weasisUrl, '_blank')
    }

    const uploadDicomToAltris = async (fileId: string) => {
      try {
        isLoading.value = true
        const response = await apiService.post(
          `/altris/upload/file/${fileId}`,
          {}
        )
        isLoading.value = false
        if (response.status === 200) {
          await studyStore.fetchStudies(
            sessionStore.patientId,
            selectedDevice.value?.id ?? ''
          )
          toast.success(t('file_upload_success'))
        } else {
          toast.error(t('file_upload_failed'))
        }
      } catch (error) {
        isLoading.value = false
        toast.error(t('file_upload_failed'))
      }
    }

    const getAltrisPdf = async (fileId: string) => {
      try {
        const pdfUrl = `${apiBaseURL}/altris/getPdf/file/${fileId}?jwt=${sessionStore.jwt}`
        console.log(pdfUrl)
        window.open(pdfUrl, '_blank')
        // const response = await apiService.get(
        //   `/altris/getPdf/file/${fileId}?jwt=${sessionStore.jwt}`
        // )
        // if (response.status === 200) {
        //   const pdfUrl = response.data as string
        //   window.open(pdfUrl, '_blank')
        //   // toast.success('PDF opened successfully')
        // } else {
        //   toast.error('Eroare la deschiderea fisierului PDF')
        // }
      } catch (error) {
        toast.error(t('error_opening_pdf'))
      }
    }

    function getDateFormat(date: string) {
      return moment(new Date(date)).format('DD.MM.YYYY HH:mm')
    }

    return {
      t,
      getDateFormat,
      isLoading,
      getAltrisPdf,
      uploadDicomToAltris,
      openDicomFile,
      deviceStore,
      selectedDevice,
      studyStore,
      selectDevice
    }
  }
})
</script>

<style scoped>
.active {
  background-color: #0d6efd !important;
  color: white !important;
}

.card {
  width: 100%;
  min-height: 240px;
}

.card-body {
  padding: 15px;
}

.card-title {
  font-size: 1rem;
}

.card-text {
  font-size: 0.9rem;
}

.cursor {
  cursor: pointer;
}

.list-group-item {
  background-color: transparent;
  font-size: 14px;
}

.list-group-item.active {
  background-color: rgb(59, 170, 227) !important;
  font-weight: bold;
}

.info-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  cursor: pointer;
}

.info-icon-error {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.btn-custom {
  border-radius: 0.8rem;
  color: #ffffff;
  font-family: 'Roboto', Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  background-color: #223f8d;
  height: 40px;
  width: 7.5rem;
  padding: 0 1rem 0 1rem;
  border: #223f8d;
}
</style>
